import { type ExportCell } from './types';

export const downloadBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  link.style.display = 'none';

  document.body.appendChild(link);

  link.click();
  link.remove();

  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);
};

export const formatCellValue = (value: ExportCell, formatDate?: (date: Date) => string) => {
  if (value instanceof Date) {
    return formatDate ? formatDate(value) : value.toISOString();
  }
  if (value === null || value === undefined) {
    return '';
  }
  return String(value);
};

export const escapeCsvValue = (value: string) => {
  const escaped = value.replace(/"/g, '""');
  return /[",\n]/.test(escaped) ? `"${escaped}"` : escaped;
};
